export const hasValue = (value, type, checked) => {
  if (type === "checkbox") {
    return checked;
  }
  if (type === "number" || type === "text" || type === "email" || type === "select-one") {
    return value !== "";
  }
};

export const isValidEmail = (value) => {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailRegex.test(value);
};

// Add more validation functions as needed
